module.exports = __webpack_public_path__ + "static/media/The_Mead_Mathematician.33ca2961.png";